import { createRouter, createWebHistory } from "vue-router";
import storage from "@/utils/storage";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import { useStore } from "@/store/index";
export const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
  },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/404"),
  },
];
export const notFoundRouter = [
  {
    path: "/:pathMatch(.*)*",
    name: "pathMatch404",
    redirect: "/404",
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const whiteList = ["/login"]; // 路由白名单
// 前置导航守卫
router.beforeEach(async (to, from, next) => {
  const store = useStore();
  const token = storage.get("token");
  Nprogress.start(); // 进入路由加载进度条
  if (token) {
    // 有token
    if (to.path === "/login") {
      next("/");
    } else {
      if (!store.myName) {
        const code = await store.getInfo();
        if (code !== 0) {
          storage.remove("token");
          next();
          return;
        }
        // console.log(store.routers);
        store.routers.forEach((i) => {
          if (!router.hasRoute(i.name)) {
            router.addRoute(i);
          }
        });
        next({ ...to, replace: true });
      } else {
        next();
      }
    }
  } else {
    // 没有token
    if (whiteList.includes(to.path)) {
      // 去的白名单里路由
      next();
    } else {
      // 重定向到登录页
      next("/login");
    }
  }
});
// 后置路由守卫
router.afterEach(() => {
  Nprogress.done();
});

export default router;
